export default "__VITE_ASSET__B8gpvvr2__"